exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.referee-name[data-v-617b837e]{ width: 33.333333%;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/views/order/agent/index.vue"],"names":[],"mappings":";AACA,gCAAgC,kBAAkB;CACjD","file":"index.vue","sourcesContent":["\n.referee-name[data-v-617b837e]{ width: 33.333333%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-617b837e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/agent/index.vue
// module id = PTen
// module chunks = 0